module.exports = __webpack_public_path__ + "img/green_032.901170fd.png";